import { render, staticRenderFns } from "./PasswordPolicie.vue?vue&type=template&id=04660c24&scoped=true&"
import script from "./PasswordPolicie.vue?vue&type=script&lang=js&"
export * from "./PasswordPolicie.vue?vue&type=script&lang=js&"
import style0 from "./PasswordPolicie.vue?vue&type=style&index=0&id=04660c24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04660c24",
  null
  
)

export default component.exports